import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';

import { ImageComponent } from '../ImageComponent/ImageComponent';

type Props = {
    imageUrl: string;
};

export const ShopWithConfidence = ({ imageUrl }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <div className="pb-xl pt-[96px] xsMax:pb-lg xsMax:pt-lg">
            <div className="mx-auto grid max-w-[1200px] grid-cols-2 items-center gap-sm xsMax:grid-cols-1 xsMax:grid-rows-[min-content_min-content] xsMax:gap-md">
                <div className="flex flex-col gap-sm pr-[40px] xsMax:row-start-2 xsMax:row-end-3 xsMax:pr-0">
                    <H2>{formatMessage({ id: 'purchaseProtectionPage.shopWithConfidence.title' })}</H2>
                    <BodyPrimary>
                        {formatMessage({ id: 'purchaseProtectionPage.shopWithConfidence.description' })}
                    </BodyPrimary>
                </div>
                <ImageComponent
                    imageUrl={imageUrl}
                    title={formatMessage({ id: 'purchaseProtectionPage.shopWithConfidence.title' })}
                />
            </div>
        </div>
    );
};
